export default "__VITE_ASSET__BsxWPVlw__"